import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7a21757f: FaireBrandEntity = {
  token: "b_7a21757f",
  type: "brand",
  name: "Benjamin International",
  avatarUrl:
    "https://cdn.faire.com/fastly/e5668dd998c24e8edae1b9aafd356cc522977cc71bdcdc925881cdb58f35e224.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d152761df9e362f4fc7ac2a7210f5a1ac32c773b2c7a384df1a4278cccdf4401.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e5668dd998c24e8edae1b9aafd356cc522977cc71bdcdc925881cdb58f35e224.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d152761df9e362f4fc7ac2a7210f5a1ac32c773b2c7a384df1a4278cccdf4401.jpeg",
  location: "Bristol, CT, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 1551,
  isInsider: true,
  description:
    "Our Mission:\n\nAt Benjamin International we are product designers, manufacturers and a conduit for global artisans and tribal communities — connecting them with boutiques, independent retailers and cultural institutions across the United States. With a strong emphasis on design and fair dealings we are happy to provide a vast array of hand picked goods for the spiritual business owner.\n\nWith over 6,000 products, we have a lot going on here at Benjamin International! Products are both American-made and imported from exotic places.\n\nAmerican-made\n  -  Designed and manufactured in the USA — bringing innovative ideas, design motifs and inspiration back from our travels to then apply to our own pieces,\n  -  Manufactured locally — promoting America’s economy and our own artisans, and\n  -  Inspired by global exposure, we create lines of gift, clothing and jewelry items.\n\nImported from exotic places like Nepal, Indonesia and India\n  -  Selected from the finest, most meaningful and ethical products,\n  -  Hand-crafted by artisans in emerging markets — Each traditional craft or product has its own special nuance and beauty. ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:28:14.610Z",
    importedBy: "entity-db-cli",
  },
};
